import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import api from "@/lib/axios";
import { useSearchParams } from "react-router-dom";
import { useTahun } from "@/hooks/useTahun";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import Rekap from "./rekap/Rekap";

const getListDataUktPendaftarLulus = async (
  page: string,
  limit: string,
  searchQuery: string,
  idsRefJalurJenis: string,
  idsUkParams: string,
  idsJenisUktParams: string,
  statussPembayaranParams: string,
  tahunParams: string,
) => {
  const params = new URLSearchParams(location.search);

  if (page) params.set("page", page);
  if (limit) params.set("limit", limit);
  if (searchQuery) params.set("searchQuery", searchQuery);
  if (idsRefJalurJenis) params.set("ids_ref_jalur_jenis", idsRefJalurJenis);
  if (idsUkParams) params.set("ids_uk", idsUkParams);
  if (idsJenisUktParams) params.set("ids_jenis_ukt", idsJenisUktParams);
  if (statussPembayaranParams)
    params.set("statuss_pembayaran", statussPembayaranParams);
  if (tahunParams) params.set("tahun", tahunParams);

  const response = await api.get(
    `/data-ukt-pendaftar-lulus/index?${params.toString()}`,
    {
      withCredentials: true,
    },
  );

  return response.data?.data;
};

export default function DataUktPendaftarLulus() {
  const { selectedTahun } = useTahun();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParams = searchParams.get("page");
  const limitParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");
  const idsRefJalurJenisParams = searchParams.get("ids_ref_jalur_jenis");
  const idsUkParams = searchParams.get("ids_uk");
  const idsJenisUktParams = searchParams.get("ids_jenis_ukt");
  const statussPembayaranParams = searchParams.get("statuss_pembayaran");

  const initialMenu = searchParams.get("menu") === "REKAP" ? "REKAP" : "DATA";
  const [activeMenu, setActiveMenu] = useState<"REKAP" | "DATA">(initialMenu);

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataUktPendaftarLulus",
      pageParams,
      limitParams,
      searchQueryParams,
      idsRefJalurJenisParams,
      idsUkParams,
      idsJenisUktParams,
      statussPembayaranParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListDataUktPendaftarLulus(
        pageParams as string,
        limitParams as string,
        searchQueryParams as string,
        idsRefJalurJenisParams as string,
        idsUkParams as string,
        idsJenisUktParams as string,
        statussPembayaranParams as string,
        selectedTahun?.label as string,
      ),
  });

  const handleTabChange = (value: string) => {
    const menu = value as "DATA" | "REKAP";
    setActiveMenu(menu);

    const newParams = new URLSearchParams(searchParams);
    newParams.set("menu", menu);
    setSearchParams(newParams);
  };

  return (
    <div>
      <Tabs defaultValue={activeMenu} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="DATA">Data UKT Pendaftar Lulus</TabsTrigger>
          <TabsTrigger value="REKAP">Rekap UKT</TabsTrigger>
        </TabsList>
        <TabsContent value="DATA">
          <DataTable
            data={data?.data || []}
            paginationData={data}
            columns={columns}
            isPending={isPending}
          />
        </TabsContent>
        <TabsContent value="REKAP">
          <Rekap />
        </TabsContent>
      </Tabs>
    </div>
  );
}
